'use client';

import { useState } from 'react';
import { AppDownloadModal } from '@components/AppDownloadModal/AppDownloadModal';
import { FAQ } from '@components/FAQ/FAQ';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import { SpeciesTopBaitNodeFields } from '@generated/graphql';
import { getFAQData } from './helpers/getFAQData';

interface IProps {
  habitatFaq?: string;
  speciesId: string;
  speciesName: string;
  topBaits?: SpeciesTopBaitNodeFields[];
}

export const SpeciesFAQSection = ({ habitatFaq, speciesId, speciesName, topBaits }: IProps) => {
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);
  const { currentPage } = useAnalytics();

  const handleCTAClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'FAQSection',
        source_id: speciesId,
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  const faqData = getFAQData({ habitatFaq, speciesName, topBaits, handleCTAClick });

  return (
    <FAQ
      className="mb-md"
      faqData={faqData}
      headingVariant="sm"
      showFAQMetaData
      title={`FAQ about ${speciesName} fishing`}
    >
      <AppDownloadModal
        appDownloadSourceId={speciesId}
        appDownloadSource="FAQSection"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </FAQ>
  );
};
